import { useNavigate } from "react-router-dom";
import { ReactNode } from "react";

const PD = "'Pretendard Variable', Pretendard, -apple-system, BlinkMacSystemFont, sans-serif";

interface Props {
  title: string;
  subtitle: string;
  updatedAt: string;
  children: ReactNode;
}

export default function LegalLayout({ title, subtitle, updatedAt, children }: Props) {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#0C0C0E]" style={{ fontFamily: PD }}>
      {/* Nav */}
      <nav className="bg-[#0C0C0E]/95 backdrop-blur border-b border-white/[0.05] px-6 h-14 flex items-center sticky top-0 z-30">
        <button
          type="button"
          onClick={() => navigate("/")}
          className="flex items-center gap-2 text-[#888888] hover:text-[#F2F2F2] text-sm transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-arrow-left-line"></i> K-ArtPEN
        </button>
      </nav>

      <div className="max-w-3xl mx-auto px-6 py-16">
        {/* Header */}
        <div className="mb-10 pb-8 border-b border-white/[0.06]">
          <p className="text-[#7A9BFF] text-xs uppercase tracking-widest mb-3">주식회사 툴뮤직 · K-ArtPEN</p>
          <h1 className="text-[#F2F2F2] text-3xl font-bold mb-3 leading-snug">{title}</h1>
          <p className="text-[#777777] text-sm">{subtitle}</p>
          <p className="text-[#555555] text-xs mt-2">최종 수정일: {updatedAt}</p>
        </div>

        {/* Content */}
        <div className="prose-custom">{children}</div>
      </div>

      {/* Footer */}
      <div className="border-t border-white/[0.05] py-8 text-center">
        <p className="text-[#555555] text-xs">© 2026 주식회사 툴뮤직. All rights reserved.</p>
        <div className="flex items-center justify-center gap-6 mt-3">
          {[
            { label: "개인정보처리방침", path: "/privacy" },
            { label: "이용약관", path: "/terms" },
            { label: "운영정책", path: "/policy" },
          ].map((l) => (
            <button key={l.label} type="button" onClick={() => navigate(l.path)}
              className="text-[#666666] hover:text-[#CCCCCC] text-xs cursor-pointer transition-colors whitespace-nowrap">
              {l.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

// 섹션 공통 컴포넌트들
export function LegalSection({ title, children }: { title: string; children: ReactNode }) {
  return (
    <section className="mb-10">
      <h4 className="text-[#F2F2F2] font-semibold text-base mb-4 flex items-center gap-2">
        <a id={title.replace(/\s/g,"-")} className="scroll-mt-20" />
        {title}
      </h4>
      <div className="text-[#888888] text-sm leading-relaxed space-y-3">{children}</div>
    </section>
  );
}

export function LegalList({ items }: { items: string[] }) {
  return (
    <ul className="space-y-2 pl-4">
      {items.map((item, i) => (
        <li key={i} className="flex items-start gap-2 text-[#888888] text-sm">
          <span className="text-[#4B6CF7] mt-1 shrink-0">·</span>
          <span>{item}</span>
        </li>
      ))}
    </ul>
  );
}
